import { NOTIFICATION_TYPES, SOCIAL_PLATFORMS } from '~/constants';

import { CreatorType, ICreator } from './creator';
import { ManagerType } from './manager';

export { NOTIFICATION_TYPES } from '~/constants';

interface INotificationGenericParams {
  creator: ICreator;
}

export interface INotification {
  id: string;
  manager: Pick<ManagerType, 'id'>;
  creator: Pick<CreatorType, 'id'>;
  type: NOTIFICATION_TYPES;
  isRead: boolean;
  createdAtAgo: string;
  updatedAtAgo: string;
  platform: SOCIAL_PLATFORMS;
  params: INotificationGenericParams;
}

export type ContentOutlierHighNotificationParams =
  INotificationGenericParams & {
    contentId: string;
    higher: number;
  };

export type ContentOutlierLowNotificationParams = INotificationGenericParams & {
  contentId: string;
  lower: number;
};

export interface IAdContentNotificationParams
  extends INotificationGenericParams {
  channel: string;
  contentId: string;
  type: string;
}

export interface IAdContentNotification extends INotification {
  params: IAdContentNotificationParams;
}

export interface IContentOutlierHighNotification extends INotification {
  params: ContentOutlierHighNotificationParams;
}
export interface IContentOutlierLowNotification extends INotification {
  params: ContentOutlierLowNotificationParams;
}
export type IContentOutlierNotification =
  | IContentOutlierHighNotification
  | IContentOutlierLowNotification;

export type MilestoneNotificationParams = INotificationGenericParams & {
  milestoneReached: number;
};

export interface IMilestoneNotification extends INotification {
  params: MilestoneNotificationParams;
}

export interface ISharedCreatorNotificationParams
  extends INotificationGenericParams {
  creatorName: string;
  managerOwnerName: string;
}

export interface ISharedCreatorNotification extends INotification {
  params: ISharedCreatorNotificationParams;
}

type UnsharedCreatorNotificationParams = INotificationGenericParams & {
  managerOwnerName: string;
};
export interface IUnsharedCreatorNotification extends INotification {
  type: NOTIFICATION_TYPES.unshareCreators;
  params: UnsharedCreatorNotificationParams;
}

export interface IDuplicateCreatorNotificationParams
  extends INotificationGenericParams {
  creatorName: string;
}

export interface IDuplicateCreatorNotification extends INotification {
  params: IDuplicateCreatorNotificationParams;
}

export type ITalentQuestionnaireNotification = INotification;

export type ISupportedNotificationType =
  | IAdContentNotification
  | IContentOutlierNotification
  | IDuplicateCreatorNotification
  | IMilestoneNotification
  | INotification
  | ISharedCreatorNotification
  | ITalentQuestionnaireNotification
  | IUnsharedCreatorNotification;
